<template>
  <div class="row">
    <div class="col">
      <table class="table table-sm table-hover" v-show="attachments?.length">
        <thead class="thead-light">
          <tr>
            <td v-if="showDate || showTime">Datum</td>
            <th>Naziv</th>
            <th v-if="showType">Tip</th>
            <th v-if="showDelete">Akcija</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="a in sortedAttachments" :class="{'table-warning': a.isForDelete}">
            <td v-if="showDate || showTime">
              {{ showDate ? $dayjs(a.dateCreated).format('DD.MM.YYYY') : '' }}
              {{ showTime ? $dayjs(a.dateCreated).format('HH:mm') : '' }}
            </td>
            <td v-if="a.hasData"><a :href="$AZURE_URI + '/Attachment/' + a.id" target="_blank" class="upload-img-link">{{ a.fileName }}</a></td>
            <td v-else>[na starem sistemu !!]</td>
            <td v-if="showType">{{ a.type }}</td>
            <td v-if="showDelete">
              <button class="btn btn-sm btn-danger" type="button" @click="$emit('delete', a.id)" v-show="!a.isForDelete">Izbriši</button>
              <span v-show="a.isForDelete" class="text-danger">Bo zbrisano, ko shraniš.</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"

defineOptions({ name: "Attachments" })

const props = defineProps({
    attachments: { type: Array, required: true },
    showDelete: { type: Boolean, default: false },
    showType: { type: Boolean, default: true },
    showDate: { type: Boolean, default: false },
    showTime: { type: Boolean, default: false },
    filterByType: { type: String, default: "" },
  })

const emit = defineEmits(["delete"])

const sortedAttachments = computed(() => {
  const filtered = (props.attachments || []).filter((a) => {
    return !props.filterByType || props.filterByType === "All" || a?.type === props.filterByType
  })

  return [...filtered].sort((a, b) => {
    const dateA = a?.dateCreated ? new Date(a.dateCreated).getTime() : 0
    const dateB = b?.dateCreated ? new Date(b.dateCreated).getTime() : 0
    return dateB - dateA
  })
})
</script>
